import React from "react"
import { Row, Col, Container, Tabs, Tab } from "react-bootstrap"

import icon from "../../images/whatsapp-icon.svg"
import { WhatsappContainer } from "../../styles/Components/SingleInstance/Whatsapp"
import Img from "../../utils/OptimizedImage"

const Whatsapp = ({ component, grid }) => (
  <WhatsappContainer
    className={`bg-plum container-${
      grid !== "" ? grid?.toLowerCase() : "normal"
    }`}
  >
    <Container>
      <Row>
        <Col>
          <div className="heading-container">
            <div className="text-center mb-4 whatsapp-icon">
              <Img src={icon} />
            </div>
            <h2 className="heading">
              Choose Clickatell as your authorized WhatsApp Business Solution
              Provider
            </h2>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className="main-section">
            <Tabs defaultActiveKey="tab1">
              <Tab
                eventKey="tab1"
                title="Clickatell is a global Meta Business Partner"
              >
                <div className="description">
                  <p>
                    We&apos;re proud to be a global Meta Business Partner with
                    vetted expertise in helping businesses advertise, sell, and
                    engage with customers on WhatsApp. As a messaging partner,
                    we&apos;re uniquely equipped to help businesses manage
                    customer conversations at scale. With our specialized
                    knowledge, we&apos;re able to create messaging experiences
                    that can automate customer service, lead generation, and
                    transactions over chat, empowering businesses to focus on
                    what they do best.
                  </p>
                  <strong>
                    Working with Meta on our customer&apos;s behalf
                  </strong>
                  <ul>
                    <li>
                      Clickatell delivers premium access to Meta&apos;s tools,
                      resources, training, and support, to maximize the value
                      and effectiveness that businesses get from the WhatsApp
                      channel.
                    </li>
                    <li>
                      We can facilitate technical integration consultations with
                      Meta&apos;s solution architects, as well as creative
                      consultations with the experts at Meta.
                    </li>
                  </ul>
                </div>
              </Tab>
              <Tab
                eventKey="tab2"
                title="Advanced Messaging Solutions & Payments in Chat"
              >
                <div className="description">
                  <p>
                    Clickatell&apos;s advanced messaging solutions go beyond
                    just WhatsApp. Our platform offers robust enterprise SMS and
                    USSD messaging solutions, and we are also currently piloting
                    Apple Messages for Business. With our assistance, you can
                    seamlessly migrate customers from traditional SMS channels
                    to richer channels like WhatsApp and Apple Messages.
                  </p>
                  <p>
                    <strong>
                      We offer additional tools that are specifically designed
                      for scalability. These tools enable businesses to quickly
                      build, test, and deploy messaging solutions on a large
                      scale.
                    </strong>
                  </p>
                  <p>
                    <strong>
                      Working with Meta on our customer&apos;s behalf.
                    </strong>
                  </p>
                  <ul>
                    <li>
                      <strong>
                        Automated app-like messaging experiences,{" "}
                      </strong>
                      with the ability to switch between channels, depending on
                      the use case.
                    </li>
                    <li>
                      <strong>Real-time, live-agent support,</strong> delivering
                      assisted messaging experiences, with a human.
                    </li>
                    <li>
                      <strong>Accept payment in messaging channels</strong> (not
                      natively available on the WhatsApp API).
                    </li>
                  </ul>
                </div>
              </Tab>
              <Tab
                eventKey="tab3"
                title="Proven Chat Commerce provider on WhatsApp"
              >
                <div className="description">
                  <p>
                    Our team is proud to have pioneered the world&apos;s first
                    chat commerce telecom solution. Today, we have enabled
                    numerous banking businesses to leverage chat commerce,
                    thanks to our innovative technology. With Clickatell&apos;s
                    preconfigured chat commerce solution, you can swiftly
                    implement automated customer engagement and commerce
                    activities for users who prefer to use mobile devices,
                    particularly on WhatsApp.
                  </p>
                  <p>
                    <strong>
                      Built for the needs of modern businesses and their brands
                    </strong>
                  </p>
                  <ul>
                    <li>Profile and account setup</li>
                    <li>Chat channel access</li>
                    <li>Real-time notifications</li>
                    <li>Fraud detection and authentication</li>
                    <li>Customer support workflow creation</li>
                    <li>Distribution of digital products with partners</li>
                    <li>Transaction facilitation and payment acceptance</li>
                  </ul>
                </div>
              </Tab>
              <Tab eventKey="tab4" title="Enterprise account management">
                <div className="description">
                  <p>
                    At Clickatell, we provide enterprise account management
                    services that go beyond just the WhatsApp API. Our dedicated
                    and personalized technical and sales support is available
                    for all your business messaging needs.
                  </p>
                  <p>
                    We prioritize encryption and security to ensure that your
                    data and messages are always protected. Additionally, you
                    can count on high levels of system uptime and performance,
                    enabling you to deliver seamless and reliable messaging
                    experiences to your customers.
                  </p>
                  <p>
                    <strong>Technical heavy lifting</strong>
                  </p>
                  <ul>
                    <li>
                      Skilled team of Solutions Architects, TAMs and CAMs to
                      drive the process and help to create messaging experiences
                      that deliver value to end-users, and grow businesses,
                      without having to worry about technical overhead.
                    </li>
                    <li>
                      System monitoring, reporting and analytics, and regular
                      system maintenance ensures business continuity and insight
                      into messaging performance.
                    </li>
                  </ul>
                </div>
              </Tab>
            </Tabs>
          </div>
        </Col>
      </Row>
    </Container>
  </WhatsappContainer>
)

export default Whatsapp
